import styled from "styled-components";

function MOContainer(props) {
  return (
    <>
      <StyledMOContainer>{props.children}</StyledMOContainer>
    </>
  );
}

export default MOContainer;

const StyledMOContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 20px 0px 20px;
`;
